<template>
  <section class="container">
    <h2 class="half-top-section mb-1">Contacto /</h2>
    <form :action="formURL" method="post">
      <div class="columns is-multiline">
        <div class="column is-half ">
          <b-field label="">
            <b-input name="name" placeholder="Nombre" required></b-input>
          </b-field>
          <b-field label="">
            <b-input
              name="email"
              type="email"
              placeholder="E-mail"
              required
            ></b-input>
          </b-field>
          <b-field label="">
            <b-input
              name="phone"
              type="text"
              placeholder="Teléfono"
              required
            ></b-input>
          </b-field>
        </div>
        <div class="column is-half">
          <b-field label="">
            <b-input
              name="comment"
              maxlength="500"
              type="textarea"
              required
              :placeholder="textArea"
            ></b-input>
          </b-field>
        </div>
        <div class="column is-full has-text-right">
          <b-button
            type="is-dark"
            tag="input"
            native-type="submit"
            value="Enviar"
          />
          <input type="hidden" name="form_tools_form_id" :value="formId" />
        </div>
      </div>
    </form>
  </section>
</template>

<style scoped lang="scss">
.column.is-full {
  padding-top: 0;
}
</style>

<script>
export default {
  name: "contact",
  mounted: function() {
    let status = this.$route.query.status;
    if (status === "ok") {
      this.$buefy.dialog.alert({
        message: "Gracias, nos pondremos en contacto contigo.",
        confirmText: "Cerrar",
        type: "is-dark"
      });
    }
  },
  data() {
    return {
      textArea: "¿Te gusta nuestro trabajo?\nEscríbenos para más información",
      formId: 17,
      formURL: "https://form.dr0m.net/process.php"
    };
  }
};
</script>
